import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },
  setBillings: set("billings"),
  setLoading: set("loading"),
  setBilling: set("billing"),
  setFilters: set("filters"),
  setCurrentUser: set("currentUser"),
  setInstallments: set("installments"),
  setConsumerUnits: set("consumer_units"),
  setConsumerUnit: set("consumer_unit"),
  setConsumerUnitFormType: set("consumer_unit_form_type"),
};
